import { useEffect, useRef, useContext, useState } from "react"
import PlannedServices2 from "../Forms/B/PlannedServices/PlannedServices2"
import { GpraContext } from "../../../context/gpraContext"
import { endpoints } from "../../../config/gpraApiEndpoints"
import { showMessage } from "../utils/utils"
import { LoaderMedium } from "../../../components/Loaders"
import { INTERVIEW_SECTIONS } from "../types/interviewTypes"
import { UserContext } from "../../../context/userContext"

const PlannedServices2Container = ({ showToolBar, disabled, interview_id }) => {
  const { interview, handleSubmitGet, handleLoadPrev, loadCollection } =
    useContext(GpraContext)
  const userCtx = useContext(UserContext)
  const [isGettingPlannedServices, setIsGettingPlannedServices] = useState(true)

  const toast = useRef()

  useEffect(() => {
    setIsGettingPlannedServices(true)
    if (
      interview[INTERVIEW_SECTIONS.RECORD_MGMT].interview_id ||
      interview_id
    ) {
      handleSubmitGet(endpoints.GET_PLANNED_SERVICES_DATA, {
        gpra_interview_id: interview_id
          ? interview_id
          : interview[INTERVIEW_SECTIONS.RECORD_MGMT].interview_id,
          organization_id: userCtx.session.user.organization_id,
        section: INTERVIEW_SECTIONS.PLANNED_SERVICES_2,
      })
        .then((response) => {
          loadCollection(
            setValues(response.data),
            INTERVIEW_SECTIONS.PLANNED_SERVICES_2
          )
          handleLoadPrev(false)
          setIsGettingPlannedServices(false)
        })
        .catch((error) => {
          showMessage(false, error, toast)
          handleLoadPrev(false)
          setIsGettingPlannedServices(false)
        })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const setValues = (data) => {
    return {
      gpra_b_services_ts_1: data?.form?.gpraBServicesTs1 ?? undefined,
      gpra_b_services_ts_2: data?.form?.gpraBServicesTs2 ?? undefined,
      gpra_b_services_ts_3: data?.form?.gpraBServicesTs3 ?? undefined,
      gpra_b_services_ts_4: data?.form?.gpraBServicesTs4 ?? undefined,
      gpra_b_services_ts_5: data?.form?.gpraBServicesTs5 ?? undefined,
      gpra_b_services_ts_6: data?.form?.gpraBServicesTs6 ?? undefined,
      gpra_b_services_ts_7: data?.form?.gpraBServicesTs7 ?? undefined,
      gpra_b_services_ts_8: data?.form?.gpraBServicesTs8 ?? undefined,
      gpra_b_services_ts_9: data?.form?.gpraBServicesTs9 ?? undefined,
      gpra_b_services_ts_10: data?.form?.gpraBServicesTs10 ?? undefined,
      gpra_b_services_ts_11: data?.form?.gpraBServicesTs11 ?? undefined,
      gpra_b_services_ts_12: data?.form?.gpraBServicesTs12 ?? undefined,
      gpra_b_services_ts_13: data?.form?.gpraBServicesTs13 ?? undefined,
      gpra_b_services_ts_14: data?.form?.gpraBServicesTs14 ?? undefined,
      gpra_b_services_ts_15: data?.form?.gpraBServicesTs15 ?? undefined,
      gpra_b_services_ts_16: data?.form?.gpraBServicesTs16 ?? undefined,
      gpra_b_services_ts_17: data?.form?.gpraBServicesTs17 ?? undefined,
      gpra_b_services_ts_18: data?.form?.gpraBServicesTs18 ?? undefined,
      gpra_b_services_ts_18a: data?.form?.gpraBServicesTs18a ?? "",
      gpra_b_services_id: data?.form?.gpraBServicesId ?? 0,
      additional: data?.additional,
    }
  }
  if (isGettingPlannedServices) {
    return <LoaderMedium></LoaderMedium>
  }
  return (
    <>
      {!isGettingPlannedServices && (
        <PlannedServices2 showToolBar={showToolBar} disabled={disabled} />
      )}
    </>
  )
}
export default PlannedServices2Container
